'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer() {
  return _react2.default.createElement(
    'footer',
    { className: 'Footer' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'ul',
        { className: 'secondary' },
        _react2.default.createElement(
          'li',
          null,
          '\xA92018 Coop\xE9rative Caligram'
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: 'http://pro.caligram.com/cgu' },
            'Conditions g\xE9n\xE9rales d\u2019utilisation'
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'primary' },
        _react2.default.createElement(_.Menu, { showSocialLinks: true })
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.js
// module id = 1079
// module chunks = 0